import { post, get } from '../index'

export default {
  // 获取公司列表
  getCompanyList () {
    return get('/company/admin/company')
  },
  // 新增 公司信息
  addCompany (querys) {
    return post('/company/admin/company', querys)
  },
  // 编辑 公司信息
  editCompany (params, querys) {
    return post(`/company/admin/company/detail${params}`, querys)
  },
  // 删除 公司信息
  delCompany (params, querys) {
    return get(`/company/admin/company/delete${params}`, querys)
  },
  // 上下架 公司信息
  changeCompany (params, querys) {
    return post(`/company/admin/company/companyChange${params}`, querys)
  },
  // 获取公司信息回显
  getCompanyInfo (querys) {
    return get('/company/admin/company/detail', querys)
  },
  // 新增 部门信息
  addDepartment (querys) {
    return post('/company/admin/department', querys)
  },
  // 编辑 部门信息
  editDepartment (params, querys) {
    return post(`/company/admin/department/detail${params}`, querys)
  },
  // 删除 部门信息
  delDepartment (params, querys) {
    return get(`/company/admin/department/delete${params}`, querys)
  },
  // 上下架 部门信息
  changeDepartment (params, querys) {
    return post(`/company/admin/department/departmentChange${params}`, querys)
  },
  // 获取部门信息
  getDepartment (querys) {
    return get('/company/admin/department', querys)
  },
  // 获取职位列表
  getPositionList (querys) {
    return get('/company/admin/job', querys)
  },
  // 添加职位
  addPositionInfo (params, querys) {
    return post(`/company/admin/job${params}`, querys)
  },
  // 编辑职位信息
  editPositionInfo (params, querys) {
    return post(`/company/admin/job/detail${params}`, querys)
  },
  // 删除职位信息
  delPositionInfo (params, querys) {
    return get(`/company/admin/job/delete${params}`, querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/company.js